export const selectExperiencePlayer = state => state.experiencePlayerManager

export const selectLink = state => selectExperiencePlayer(state).link

export const selectIsCreating = state =>
  selectExperiencePlayer(state).isCreating

export const selectIsPolling = state => selectExperiencePlayer(state).isPolling

export const selectError = state => selectExperiencePlayer(state).error

export const selectIsExpired = state => {
  const link = selectLink(state)
  if (!link) return false
  if (!link.isValid) return true
  if (!link.expiresAt) return false
  return new Date(link.expiresAt) <= new Date()
}

export const selectTimeUntilExpiry = state => {
  const link = selectLink(state)
  if (!link?.expiresAt) return null
  const diff = new Date(link.expiresAt) - new Date()
  return diff > 0 ? diff : 0
}
